import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'service-support',
    name: 'Service & Support',
    description: 'Cases, SLAs, queues and customer communication.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'service-support',
    features: [
        {
            key: 'service_support.sla_management',
            description: 'Contractual SLA tracking and escalation',
        },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds SLA management',
            features: ['service_support.sla_management'],
            limits: ['user', 'active_user', 'transaction'],
        },
    ],
    limitTypes: ['user', 'active_user', 'transaction'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'notifications',
        'party_master',
        'attachments',
    ],
    optionalModules: ['field-service', 'crm'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map